import { handleActions } from "redux-actions";

import {
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_MODULE_VIEW,
  SET_LOADING,
  SET_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  DATA_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  UPDATE_FILTER,
  UPDATE_DATES,
  RESET_SELECTED_FILTERS
} from "./activePackagesSaga";
import {
  getDateRanges,
  getMonthlyRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  isLoading: false,
  chartData: { data_table: {} },
  moduleView: [
    { id: "details", name: "Details" },
    { id: "trend", name: "Trend" }
  ],
  rangeOptions: [],
  selectedFilters: {
    moduleView: { id: "details", name: "Details" },
    rangeOption: {},
    requestDates: {},
    date: null
  },
  tableInfo: {},
  initialRequest: false,
  filtersDirty: false
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      initialRequest: true,
      currentUser: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        date: action.payload.calendarEndDate
      }
    }),
    [DATA_SUCCESS]: (state, action) => {
      if (state.selectedFilters.moduleView.id === "details") {
        return {
          ...state,
          tableInfo: action.payload.table_data,
          dataPoints: action.payload.data_points
        };
      }
      return {
        ...state,
        chartData: action.payload
      };
    },
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data
      }
    }),
    [RESET_SELECTED_FILTERS]: (state) => ({
      ...state,
      selectedFilters: {
        ...initialState.selectedFilters,
        moduleView: state.selectedFilters.moduleView
      }
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getMonthlyRangeOptions(state.currentUser.calendarEndDate);

      return {
        ...state,
        rangeOptions: [...rangeOptions, getSelectedRangeOptionWithCustom(action)],
        selectedFilters: {
          ...state.selectedFilters,
          rangeOption: getSelectedRangeOptionWithCustom(action),
          date: state.currentUser.calendarEndDate,
          requestDates: action.payload
        }
      };
    },
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        rangeOption: getSelectedRangeOptionWithCustom(action),
        requestDates: action.payload || state.selectedFilters.requestDates
      },
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      filtersDirty: true
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        rangeOption: action.payload,
        requestDates: getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.currentUser.calendarStartDate
        )
      },
      filtersDirty: true
    }),
    [SET_MODULE_VIEW]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        moduleView: action.payload
      }
    })
  },
  initialState
);
